const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Full-size picture served by the backend.
export const imageUrl = (path) => `${API_BASE_URL}/storage/${path}`;

// The backend stores a small "<name>-thumb.webp" next to every optimized "<name>.webp".
// Lists and cards use it; older pictures that have no thumbnail fall back to the full file.
export const thumbUrl = (path) =>
  /\.webp$/i.test(path)
    ? `${API_BASE_URL}/storage/${path.replace(/\.webp$/i, "-thumb.webp")}`
    : imageUrl(path);

// Props for an <img> that shows a thumbnail, loads lazily and falls back to the full picture
// if the thumbnail does not exist: <img {...thumbProps(path)} alt="" />
export const thumbProps = (path) => ({
  src: thumbUrl(path),
  loading: "lazy",
  decoding: "async",
  onError: (e) => {
    const full = imageUrl(path);
    if (e.currentTarget.src !== full) e.currentTarget.src = full;
  },
});
